export enum AccessibilityRole {
  PRESENTATION = 'presentation',
  NORMAL = 'normal',
}

export const LAYOUT_DEFAULT_ACCESSIBILITY_ROLE: AccessibilityRole = AccessibilityRole.PRESENTATION;
export const IMAGE_CELL_DEFAULT_ACCESSIBILITY_ROLE: AccessibilityRole = AccessibilityRole.NORMAL;
